// extracted by mini-css-extract-plugin
export var label = "_dh-5";
export var slideContainer = "_dh-0";
export var slider = "_dh-1";
export var sliderLg = "_dh-4";
export var sliderMd = "_dh-3";
export var sliderSm = "_dh-2";